// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  0%  {transform: translateY(0);} 
  100% {transform: translateY(-3px);}
`;

const S = {
  Progress: styled.div`
    margin-top: 20px;
    width: 100%;
  `,
  ProgressInner: styled.div`
    vertical-align: middle;
    display: flex;
    background: #eeeeee;
    border-radius: 100px;
    position: relative;
    width: 100%;
  `,
  ProgressPercent: styled.div`
    text-align: right;
    font-size: 14px;
    color: #313C42;
    width: 0%;
  `,
  ProgressBg: styled.div<{ percent:number }>`
    background-color: #EF8200;;
    width: ${props => props.percent}%;
    border-radius: 100px;
    height: 14px;
  `,
  ProgressCount: styled.div`
    font-size: 14px;
    color: #666666;
    margin-bottom: 5px;
    text-align: right;
  `,
  ProgressTitle: styled.div`
    display: flex;
    justify-content: space-between;
  `,
  ProgressText: styled.div`
    justify-content: center;
    font-size: 14px;
    color: #666666;
    margin-top: 5px;
    display: flex;
  `,
  ProgressAnimate: styled.p`
    animation: ${bounce} .6s ease infinite alternate;
    &:nth-child(1){
      animation-delay: 0s;
      margin-left: 3px;
    }
    &:nth-child(2){
      animation-delay: .2s;
      padding: 0 3px;
    }
    &:nth-child(3){
      animation-delay: .4s;
    }
  `,
};

export default S;
